module.exports = __webpack_public_path__ + "img/symbol_4.850071b8.png";